import {
    API_EC,
    API_HOME_PAGE,
    API_MALL,
    API_PRODUCTS_CLASSIFICATION,
} from '@/config/api.config';
import type {
    ApiEcConfig,
    ApiHomePageConfig,
    ApiProductsClassificationConfig,
    RuntimeApiConfig,
} from '@/types/config/api-config.types';
import type { EnvConfig } from '@/types/config/env-config.types';

const BRIDGE_EC_KEYS: Array<keyof ApiEcConfig> = [
    'LOGIN',
    'LOGOUT',
    'GET_MEMBER_INFO',
    'GET_PRODUCT_MAIN_CLASS_TREE',
    'GET_PRODUCT_POSTPROCESSING_DETAIL',
];

/**
 * 串接 bridge 專用 URL
 */
const withBaseUrl = (baseUrl: string, path: string): string => {
    const isAbsoluteUrl = /^https?:\/\//i.test(path);
    if (isAbsoluteUrl) {
        return path;
    }

    return `${baseUrl}${path}`;
};

/**
 * 建立 bridge 專用 API 設定
 * 僅 bridge 需要 baseUrl 串接
 */
export const createBridgeApiConfig = (
    envConfig: EnvConfig
): RuntimeApiConfig => {
    const bridgeHomePage: ApiHomePageConfig = {
        PRODUCT_THEME_LIST: withBaseUrl(
            envConfig.EC_BASE_URL,
            API_HOME_PAGE.PRODUCT_THEME_LIST
        ),
        HOME_PRODUCT_LIST: withBaseUrl(
            envConfig.EC_BASE_URL,
            API_HOME_PAGE.HOME_PRODUCT_LIST
        ),
        NEWS_LIST: withBaseUrl(envConfig.EC_BASE_URL, API_HOME_PAGE.NEWS_LIST),
    };

    const bridgeProductsClassification: ApiProductsClassificationConfig = {
        PRODUCT_MAIN_CLASS_TREE: withBaseUrl(
            envConfig.EC_BASE_URL,
            API_PRODUCTS_CLASSIFICATION.PRODUCT_MAIN_CLASS_TREE
        ),
        PRODUCT_MAIN_CLASS_DETAIL: withBaseUrl(
            envConfig.EC_BASE_URL,
            API_PRODUCTS_CLASSIFICATION.PRODUCT_MAIN_CLASS_DETAIL
        ),
        PRODUCT_POSTPROCESSING_DETAIL: withBaseUrl(
            envConfig.EC_BASE_URL,
            API_PRODUCTS_CLASSIFICATION.PRODUCT_POSTPROCESSING_DETAIL
        ),
    };

    const bridgeEcConfig: ApiEcConfig = {
        ...API_EC,
    };

    BRIDGE_EC_KEYS.forEach((key) => {
        bridgeEcConfig[key] = withBaseUrl(envConfig.EC_BASE_URL, API_EC[key]);
    });

    return {
        API_HOME_PAGE: bridgeHomePage,
        API_ProductsClassification: bridgeProductsClassification,
        API_EC: bridgeEcConfig,
        API_MALL,
    };
};
